import Vue            from 'vue/dist/vue.esm.js'
import VueRouter      from 'vue-router';
import { store }      from './store';
import bus            from './bus.js';
import footerplayer   from '@/components/FooterPlayer.vue';
import addtocartmodal from '@/components/AddToCartModal.vue';
import freedownloadmodal from '@/components/FreeDownloadModal.vue';
import pricingdetailsmodal from '@/components/PricingDetailsModal.vue';
import VueLazyload    from 'vue-lazyload';
import routes from './routes.js';
import { fetchMetaInfoFromCurrentPage } from './metaService.js';

Vue.use( VueLazyload );
Vue.use( VueRouter );

const router = new VueRouter({
	routes: routes,
	mode: 'history',
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
});


router.afterEach( async(to, from, next) => {
	
	// Attempt to fetch meta information from the current page
	const metaInfo = await fetchMetaInfoFromCurrentPage();
	if ( metaInfo ) {
		document.title = metaInfo.title;
		const metaDescription = document.querySelector('meta[name="description"]');
		
		if ( metaDescription && metaInfo.description ) {
			metaDescription.setAttribute('content', metaInfo.description);
		
		} else if (metaInfo.description) {
			const meta = document.createElement('meta');
			meta.name = 'description';
			meta.content = metaInfo.description;
			document.getElementsByTagName('head')[0].appendChild(meta);
		
		}

		if ( metaDescription && ! metaInfo.description ) {
			// metaDescription.remove();
		}
	} else {
		console.log('fallback to nearest meta', to.matched);
		// Fallback to nearest route meta information
		const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
		const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
	
		// If a route with a title was found, set the document (page) title to that value.
		if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
	
		// Remove any stale meta tags from the document using the key attribute we set below.
		Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
	
		// Skip rendering meta tags if there are none.
		if (nearestWithMeta) {
			// Turn the meta tag definitions into actual elements in the head.
			nearestWithMeta.meta.metaTags.map(tagDef => {
				const tag = document.createElement('meta');

				Object.keys(tagDef).forEach(key => {
					tag.setAttribute(key, tagDef[key]);
				});

				// We use this to track which meta tags we create, so we don't interfere with other ones.
				tag.setAttribute('data-vue-router-controlled', '');

				return tag;
		  })
			// Add the meta tags to the document head.
			.forEach(tag => document.head.appendChild(tag));
		}
	  
		// Google Analytics tracking
		if (typeof gtag !== 'undefined') {
			gtag('config', window.dataLayer[1][1], {
				'page_path': to.path
			});
		} else if (typeof ga !== 'undefined') {
			ga('set', 'page', to.path);
			ga('send', 'pageview');
		} else {
			/* NO GA TRACKING SCRIPT FOUND. */
		}
		
		// Facebook Pixel tracking
		if (typeof fbq !== 'undefined') {
			fbq('track', 'PageView');
		}
	}
});

Vue.prototype.$pricingData = {
	columnOne:        ui_pricing_data.pricingColumnOne,
	columnTwo:        ui_pricing_data.pricingColumnTwo,
	columnThree:      ui_pricing_data.pricingColumnThree,
	columnFour:       ui_pricing_data.pricingColumnFour,
	columnOneName:    ui_pricing_data.columnOneName,
	columnTwoName:    ui_pricing_data.columnTwoName,
	columnThreeName:  ui_pricing_data.columnThreeName,
	columnFourName:   ui_pricing_data.columnFourName,
	columnOnePrice:   ui_pricing_data.columnOnePrice,
	columnTwoPrice:   ui_pricing_data.columnTwoPrice,
	columnThreePrice: ui_pricing_data.columnThreePrice,
	columnFourPrice:  ui_pricing_data.columnFourPrice,
	columnOneLinkType:    ui_pricing_data.columnOneLinkType,
	columnTwoLinkType:    ui_pricing_data.columnTwoLinkType,
	columnThreeLinkType:  ui_pricing_data.columnThreeLinkType,
	columnFourLinkType:   ui_pricing_data.columnFourLinkType,
	columnOneUrl:         ui_pricing_data.columnOneUrl,
	columnTwoUrl:         ui_pricing_data.columnTwoUrl,
	columnThreeUrl:       ui_pricing_data.columnThreeUrl,
	columnFourUrl:        ui_pricing_data.columnFourUrl,
	columnOnePopupContent:    ui_pricing_data.columnOnePopupContent,
	columnTwoPopupContent:    ui_pricing_data.columnTwoPopupContent,
	columnThreePopupContent:  ui_pricing_data.columnThreePopupContent,
	columnFourPopupContent:   ui_pricing_data.columnFourPopupContent,
}

// Create and mount the root instance.
const app = new Vue({
	el: '#app',
	store,
	data: {
		errors: [],
		hasBorder: false,
		showModal: false,
		showFreeDownloadModal: false,
		showPricingModal: false,
		modalTrackName: '',
		footerActive: false,
		mobileNavVisible: false,
		dropDownOpen: false,
		searchPanelVisible: false,
		isPlaying: false,
		showFooterCart: false,
		email: '',
	},
	methods: {
		searchForBeat( e ){
			router.push({ path: ui_data.site_url_relative + 'search', query: { q: e.target.value } });
			this.$store.commit( 'updateSearchQuery', e.target.value );
		},
		toggleNav(){
			this.mobileNavVisible = ! this.mobileNavVisible;
		},
		toggleSearch() {
			this.searchPanelVisible = ! this.searchPanelVisible;
		},
		checkViewportWidth() {
			return window.matchMedia("(min-width: 990px)").matches;
		},
		updateFeaturedBeats() {
			bus.$emit( 'updateFeaturedBeats' );
		},
		submit( email ) {
			axios.post( '/wp-json/beatstore/v1/newsletter', {
				email: email,
			})
			.then( function ( response ) {
				
			})
			.catch(function ( error ) {
				console.log( error );
			})
		}
	},
	components: {
		footerplayer,
		addtocartmodal,
		pricingdetailsmodal,
		freedownloadmodal,
	},
	created: function () {
		let vm = this;

		bus.$on( 'showModal', ( ) => {
			this.showModal = true;
		});

		bus.$on( 'hideModal', ( ) => {
			this.showModal = false;
		});

		bus.$on( 'openDownloadModal', (track) => {
			this.showFreeDownloadModal = true;
		});

		bus.$on( 'showPricingModal', () => {
			this.showPricingModal = true;
		});

		bus.$on( 'hidePricingModal', () => {
			this.showPricingModal = false;
		});

		bus.$on( 'footerActive', ( ) => {
			this.footerActive = true;
		});

		bus.$on( 'toggleFooterCart', ( ) => {
			this.showFooterCart = ! this.showFooterCart;
		});
	},
	mounted: function () {
		// Fade in border.
		setTimeout( function () {
			this.hasBorder = true
		}.bind(this), 400);

		// Esc key close modal.
		document.addEventListener( 'keydown', ( e ) => {
			if ( this.showModal == true && e.keyCode === 27 ) {
				this.showModal = false;
			}

			if ( this.showPricingModal === true && e.keyCode === 27 ) {
				this.showPricingModal = false;
			}

			if ( this.showFreeDownloadModal === true && e.keyCode === 27 ) {
				this.showFreeDownloadModal = false;
			}
		});

		document.addEventListener('ui_added_to_cart', (e) => {
			setTimeout(() => {
				this.showModal = false;
			}, 500);
			
		});

		// Keep the player alive by letting Vue Router handle internal content links.
		const legacyHashSlugs = {
			'#terms': 'terms',
			'#privacy': 'privacy',
			'#disclaimer': 'disclaimer',
			'#cookies': 'cookies',
			'#faq': 'faq',
			'#upgrade-license': 'upgrade-license',
		};

		const getLegacyHashRoute = ( hash ) => {
			const slug = legacyHashSlugs[ hash ];

			if ( ! slug ) {
				return '';
			}

			const page = ( ui_data.staticPages || [] ).find( item => item.slug === slug );
			const path = page ? page.path : '/' + slug + '/';
			const resolved = router.resolve( path );

			return resolved.route.matched.length ? path : '';
		};

		const initialLegacyRoute = getLegacyHashRoute( window.location.hash );

		if ( initialLegacyRoute ) {
			router.replace( initialLegacyRoute ).catch( () => {} );
		}

		document.addEventListener( 'click', ( e ) => {
			if ( e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ) {
				return;
			}

			const link = e.target.closest ? e.target.closest( 'a[href]' ) : null;

			if ( ! link || ( link.target && link.target !== '_self' ) || link.hasAttribute( 'download' ) ) {
				return;
			}

			const href = link.getAttribute( 'href' );

			if ( ! href ) {
				return;
			}

			if ( href.charAt( 0 ) === '#' ) {
				const legacyRoute = getLegacyHashRoute( href );

				if ( legacyRoute ) {
					e.preventDefault();
					router.push( legacyRoute ).catch( () => {} );
				}

				return;
			}

			let url;

			try {
				url = new URL( link.href, window.location.href );
			} catch ( error ) {
				return;
			}

			if ( url.origin !== window.location.origin ) {
				return;
			}

			// URLs with query parameters are handled server-side (EDD, license upgrades, etc.).
			if ( url.search ) {
				return;
			}

			if ( url.hash ) {
				const legacyRoute = getLegacyHashRoute( url.hash );

				if ( legacyRoute ) {
					e.preventDefault();
					router.push( legacyRoute ).catch( () => {} );
				}

				return;
			}

			const resolved = router.resolve( url.pathname + url.search );

			if ( ! resolved.route.matched.length ) {
				return;
			}

			e.preventDefault();
			router.push( url.pathname + url.search ).catch( () => {} );
		} );

		const checkoutFrame = document.getElementById( 'mt-co-frame' );

		if ( checkoutFrame ) {
			const syncCheckoutFrameTheme = () => {
				try {
					const theme = document.documentElement.getAttribute( 'data-theme' ) || 'dark';
					const frameDoc = checkoutFrame.contentDocument;

					if ( ! frameDoc ) {
						return;
					}

					frameDoc.documentElement.setAttribute( 'data-theme', theme );
					frameDoc.documentElement.style.colorScheme = theme;
				} catch ( error ) {}
			};

			checkoutFrame.addEventListener( 'load', syncCheckoutFrameTheme );

			new MutationObserver( syncCheckoutFrameTheme ).observe( document.documentElement, {
				attributes: true,
				attributeFilter: [ 'data-theme' ],
			} );
		}

		jQuery('body').on('edd_cart_item_added', function() { 
			if ( typeof fbq !== 'undefined' ) {
				fbq('track', 'AddToCart');
			}
		});

	},
	router: router

}).$mount( '#app' )
